export var VALIDATE_LIST = [{
  key: ['VIDEO_MEDIA_DURATION'],
  label: '时长',
  value: '≤ 90秒'
}, {
  label: '格式',
  value: 'MP4'
}, {
  label: '视频编码',
  value: 'H.264/AVC'
}, {
  label: '格式类型',
  value: 'High Profile'
}, {
  key: ['VIDEO_MEDIA_ASPECTRATIO'],
  label: '宽高比',
  value: '4:3'
}, {
  key: ['VIDEO_MEDIA_WIDTH', 'VIDEO_MEDIA_WIDTH'],
  label: '分辨率',
  value: '750 × ≤1536px'
}, {
  label: '文件大小',
  value: '≤ 5MB'
}, {
  label: '视频码率',
  value: '600~1000 kbit/s'
}, {
  label: '帧率',
  value: '推荐 24 fps'
}];